var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666016 5C1.81935 2.07333 4.66602 0 7.99935 0C11.3327 0 14.1793 2.07333 15.3327 5C14.1793 7.92667 11.3327 10 7.99935 10C4.66602 10 1.81935 7.92667 0.666016 5ZM13.8795 5C12.7795 2.75333 10.5261 1.33333 7.99945 1.33333C5.47279 1.33333 3.21945 2.75333 2.11945 5C3.21945 7.24667 5.47279 8.66667 7.99945 8.66667C10.5261 8.66667 12.7795 7.24667 13.8795 5ZM7.99935 3.33333C8.91935 3.33333 9.66602 4.08 9.66602 5C9.66602 5.92 8.91935 6.66667 7.99935 6.66667C7.07935 6.66667 6.33268 5.92 6.33268 5C6.33268 4.08 7.07935 3.33333 7.99935 3.33333ZM4.99935 5C4.99935 3.34667 6.34602 2 7.99935 2C9.65268 2 10.9993 3.34667 10.9993 5C10.9993 6.65333 9.65268 8 7.99935 8C6.34602 8 4.99935 6.65333 4.99935 5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibility);
export default __webpack_public_path__ + "static/media/visibility.4251ba549a573fa6cf81675970c76c5d.svg";
export { ForwardRef as ReactComponent };